module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/locales/en.json
// module id = 1797
// module chunks = 0